export const ACCESS_TOKEN_KEY = 'ACCESS_TOKEN_KEY';
export const ACCESS_TOKEN_EXPIRY_KEY = 'ACCESS_TOKEN_EXPIRY_KEY';
export const RESET_TOKEN_KEY = 'RESET_TOKEN_KEY';
export const REFRESH_TOKEN_KEY = 'REFRESH_TOKEN_KEY';
export const USER_ID = 'USER_ID';
export const USER_PERMISSIONS = 'USER_PERMISSIONS';
